import { render, staticRenderFns } from "./Meat.vue?vue&type=template&id=5e4175f4&scoped=true"
import script from "./Meat.vue?vue&type=script&lang=js"
export * from "./Meat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4175f4",
  null
  
)

export default component.exports